/**
 * Enlace `mailto:` para abrir el programa de correo con el destinatario y,
 * si lo hay, el asunto ya escritos. El asunto se codifica entero, así que
 * acepta espacios, acentos y separadores como «·».
 */
export function buildMailto(email: string, subject?: string): string {
  const base = `mailto:${email.trim()}`;
  const cleanSubject = subject?.trim();

  return cleanSubject ? `${base}?subject=${encodeURIComponent(cleanSubject)}` : base;
}
